var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/no-array-index-key */
import React from 'react';
import MuiSelect from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { FiChevronDown } from 'react-icons/fi';
import FormHelperText from '@material-ui/core/FormHelperText';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: "1px solid " + theme.palette.grey[500],
            borderRadius: 6,
        },
    },
    icon: {
        marginRight: theme.spacing(1),
        fontSize: 27,
        color: theme.palette.primary.main,
    },
    label: {
        color: theme.palette.primary.main,
    },
}); });
var Select = function (_a) {
    var _b;
    var children = _a.children, disabled = _a.disabled, helperText = _a.helperText, error = _a.error, fullWidth = _a.fullWidth, label = _a.label, items = _a.items, variant = _a.variant, IconComponent = _a.IconComponent, onBlur = _a.onBlur, inputLabelProps = _a.inputLabelProps, props = __rest(_a, ["children", "disabled", "helperText", "error", "fullWidth", "label", "items", "variant", "IconComponent", "onBlur", "inputLabelProps"]);
    var classes = useStyles();
    return (React.createElement(FormControl, { error: error, fullWidth: fullWidth, variant: variant, classes: { root: classes.root }, disabled: disabled },
        React.createElement(InputLabel, __assign({ className: classes.label }, inputLabelProps), label),
        React.createElement(MuiSelect, __assign({ fullWidth: fullWidth, variant: variant, label: label, IconComponent: IconComponent || FiChevronDown, classes: { icon: classes.icon }, onBlur: onBlur, disabled: disabled }, props), children
            || ((_b = items) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
                return (React.createElement(MenuItem, { key: index, value: item.value }, item.label));
            }))),
        React.createElement(FormHelperText, null, helperText)));
};
Select.defaultProps = {
    disabled: false,
    helperText: '',
    label: '',
    items: [],
    fullWidth: false,
    error: false,
};
export default Select;
//# sourceMappingURL=Select.js.map